import { render, staticRenderFns } from "./AccountInfomation.vue?vue&type=template&id=5ba5464b&"
import script from "./AccountInfomation.vue?vue&type=script&lang=js&"
export * from "./AccountInfomation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports